export default __webpack_public_path__ + "static/media/area-23.09a58ff4.jpg";